import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { auth } from '../firebase';
import { onAuthStateChanged, signOut } from 'firebase/auth';
import { canPost } from '../config/allowlist';

const styles = {
  nav: {
    backgroundColor: '#F7F5F0',
    borderBottom: '1px solid #E0DDD6',
    padding: '0 2rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '64px',
    position: 'sticky',
    top: 0,
    zIndex: 100,
  },
  logo: {
    fontFamily: 'Playfair Display, Georgia, serif',
    fontSize: '28px',
    fontWeight: 400,
    letterSpacing: '-1px',
    textDecoration: 'none',
  },
  hostel: { color: '#111110' },
  chic: { color: '#4A9E8A' },
  navLinks: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    listStyle: 'none',
  },
  navLink: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '14px',
    color: '#888880',
    textDecoration: 'none',
    letterSpacing: '0.3px',
  },
  authButtons: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  loginBtn: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#111110',
    textDecoration: 'none',
    padding: '7px 16px',
    border: '1px solid #E0DDD6',
    borderRadius: '4px',
    backgroundColor: 'transparent',
    cursor: 'pointer',
  },
  postBtn: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#F7F5F0',
    textDecoration: 'none',
    padding: '7px 16px',
    border: '1px solid #4A9E8A',
    borderRadius: '4px',
    backgroundColor: '#4A9E8A',
    cursor: 'pointer',
  },
  userEmail: {
    fontFamily: 'DM Sans, system-ui, sans-serif',
    fontSize: '13px',
    color: '#888880',
  },
};

function Navbar() {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
    });
    return () => unsubscribe();
  }, []);

  const handleSignOut = async () => {
    await signOut(auth);
    navigate('/');
  };

  return (
    <nav style={styles.nav}>
      <Link to="/" style={styles.logo}>
        <span style={styles.hostel}>Hostel</span>
        <span style={styles.chic}>Chic</span>
      </Link>

      <ul style={styles.navLinks}>
        <li><Link to="/stays" style={styles.navLink}>Stays</Link></li>
      </ul>

      <div style={styles.authButtons}>
        {user ? (
          <>
            <span style={styles.userEmail}>{user.email}</span>
            <Link to="/account" style={styles.loginBtn}>My Listings</Link>
            <button style={styles.loginBtn} onClick={handleSignOut}>Sign out</button>
            {canPost(user) && <Link to="/post" style={styles.postBtn}>+ Post Listing</Link>}
          </>
        ) : (
          <>
            <Link to="/login" style={styles.loginBtn}>Log in</Link>
            <Link to="/signup" style={styles.loginBtn}>Sign up</Link>
          </>
        )}
      </div>
    </nav>
  );
}

export default Navbar;